import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MechanicsService } from '../_services/mechanics.service';

@Component({
  selector: 'dialog-options',
  templateUrl: './dialog-options.component.html',
  styleUrl: './dialog-options.component.css'
})
export class DialogOptionsComponent {

	constructor(public ms: MechanicsService, private router: Router) { }

	close() {
		const l = `close() - `
		window["dialogOptions"].close()
	}

	onModeChange(selectedMode: string) {
		// Save the preference and navigate immediately
		this.ms.preferences.selectedMode = selectedMode;
		this.ms.savePreferences();
		this.router.navigate([selectedMode]);
	}
}
